import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sendMsg",
  "use": "icon-sendMsg-usage",
  "viewBox": "0 0 29.277189254760742 27.29306411743164",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 29.277189254760742 27.29306411743164\" id=\"icon-sendMsg\"><g><path d=\"M9.66694,17.3498L0,11.4613L29.2772,0L24.1508,26.3701L11.6779,18.382L22.8267,6.34631L9.66694,17.3498ZM11.7645,20.5281L11.7645,27.2931L15.8978,23.0969L11.7645,20.5281Z\" fill=\"#FFFFFF\" fill-opacity=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sendMsg.svg
// module id = xK30
// module chunks = 103